import React, { FC } from 'react'
import { usePagination, DOTS } from './usePagination'
import {
  PaginationContainer,
  IconWrapper,
  PaginationItem,
  DotsWrapper,
} from './Pagination.styles'
import { PaginationProps } from './types'
import Font from '../../Core/Typography/Font/Font'
import Icon from '../../Core/Iconography/Icon/Icon'

const Pagination: FC<PaginationProps> = props => {
  const { onPageChange, totalPages, currentPage } = props

  const paginationRange = usePagination({
    currentPage,
    totalPages,
  })

  if (currentPage === 0 || paginationRange?.length < 2 || !paginationRange) {
    return null
  }

  return (
    <PaginationContainer>
      <PaginationItem
        onClick={() => {
          onPageChange(currentPage - 1)
        }}
        disabled={currentPage === 1}
      >
        <IconWrapper disabled={currentPage === 1}>
          <Icon name='chevron-left' size='s' color='dark' />
        </IconWrapper>
      </PaginationItem>
      {paginationRange?.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <DotsWrapper key={index}>
              <Font>&#8230;</Font>
            </DotsWrapper>
          )
        }
        return (
          <PaginationItem
            key={index}
            selected={pageNumber === currentPage}
            onClick={() => onPageChange(pageNumber as number)}
          >
            <Font color={pageNumber === currentPage ? 'blank' : 'dark'}>
              {pageNumber}
            </Font>
          </PaginationItem>
        )
      })}
      <PaginationItem
        onClick={() => {
          onPageChange(currentPage + 1)
        }}
        disabled={currentPage === totalPages}
      >
        <IconWrapper disabled={currentPage === totalPages}>
          <Icon name='chevron-right' size='s' color='dark' />
        </IconWrapper>
      </PaginationItem>
    </PaginationContainer>
  )
}

export default Pagination
